import { useEffect } from 'react';

import OutOfCoins from '../components/OutOfCoins/OutOfCoins';
import { useStores } from '../stores/useStores';

export const useCcLowBalance = () => {
  const { lowBalanceStore } = useStores();

  useEffect(() => {
    lowBalanceStore.OutOfCoinsComponent = OutOfCoins;
  }, [lowBalanceStore]);
};
